export default __webpack_public_path__ + "static/shopify-a8f1a6fcacbdd69ef354958fd9613d29.png";